import useDestinationClipModal from "../destination/useDestinationClipModal";
import useTransferLocations from "./useTransferLocations";

/**
 * Drives the Clip Preview "Transfer" flow (move/deliver an asset to an
 * approved transfer location — an Iconik storage). A thin wrapper over the
 * shared destination-clip modal, wired to the transfer-locations source +
 * POST /transfer. Kept separate from Export per product decision.
 */
const useTransferClipModal = () => {
  const { locations, loading, getLocations, transferAssets } =
    useTransferLocations();

  return useDestinationClipModal({
    verb: "Transfer",
    locations,
    locationsLoading: loading,
    getLocations,
    submit: transferAssets,
    destinationLabel: "Transfer Destination",
    destinationDescription:
      "The approved Iconik transfer location (storage) these clips will be sent to.",
  });
};

export default useTransferClipModal;
